import { env } from '@/env'

export const ENABLE_DEV_GUI = env.REACT_APP_ENABLE_DEV_GUI === 'true'
export const ENABLE_SECONDARY_MARKET_C2A =
  env.REACT_APP_ENABLE_SECONDARY_MARKET_C2A === 'true'
